import { HTMLAttributes, ReactNode } from "react"
import { twMerge } from "tailwind-merge"


interface RootProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}

export function Root({ children, ...rest }: RootProps) {
    return (
        <div className={twMerge("", rest.className)} {...rest} >
            {children}
        </div>
    )
}
